<span [attr.role]="sortType ? 'button' : null"
  [attr.tabindex]="sortType ? 0 : null"
  (click)="click()"
  (keydown.enter)="onActivateKey($event)"
  (keydown.space)="onActivateKey($event)"
  class="column-header">
  @if (labelIconName) {
    <sb-icon name="{{labelIconName}}"></sb-icon>
  }
  <span [innerHTML]="label | translate"></span>
  @if (toolTip) {
    <sup ngbTooltip="{{toolTip | translate}}">?</sup>
    }&nbsp;
    @if (sortType && sortType != fieldName) {
      <sb-icon name="unsorted"></sb-icon>
    }
    @if (sortType && sortType == fieldName && !sortReverse) {
      <sb-icon name="sortDown"></sb-icon>
    }
    @if (sortType && sortType == fieldName && sortReverse) {
      <sb-icon name="sortUp"></sb-icon>
    }
  </span>